import { store } from "@/index";
import type { Middleware } from "@/shared/utils/middleware.util";

const getToken = () => {
  const envToken = process.env.REACT_APP_TOKEN;
  const { auth, organization } = store.getState();
  const reduxToken = organization.token || auth.token;
  return envToken || reduxToken;
};

const tokenMiddleware: Middleware = {
  request: async (url, init = {}) => {
    const token = getToken();

    // Create a new headers object by merging with the existing headers
    const headers = {
      ...init.headers,
      Authorization: `Bearer ${token}`,
    };

    // Return a new init object with updated headers
    const newInit = {
      ...init,
      headers,
    };

    return [url, newInit];
  },
};
export default tokenMiddleware;
